.root {
  display: flex;
  align-items: center;
  width: min-content;
  color: var(--white);
  border-radius: 4px;
}

.size {
  position: relative;

  &::before {
    display: block;
    width: 100%;
    padding-top: 100%;
    content: "";
  }
}

.md {
  width: 32px;
}

.sm {
  width: 24px;

  & ~ * {
    font-size: var(--font-size-body-2);
    font-weight: var(--font-weight-regular);
  }
}

.content {
  padding-right: 0.25rem;
  white-space: nowrap;
}

.icon {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 75%;
  height: 75%;
  border-radius: 4px;
  transform: translate(-50%, -50%);
}

.yellow {
  color: var(--gray-900);
  background-color: var(--sentiment-warning);
}

.pink {
  background-color: var(--pink-800);
}

.purple {
  background-color: var(--primary-600);
}

.red {
  background-color: var(--sentiment-negative);
}

.green {
  background-color: var(--sentiment-positive);
}

.blue {
  background-color: var(--blue-500);
}
